import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(11, 15, 25, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  height: 70px;
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 0 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  @media (min-width: 1024px) {
    padding: 0 10%;
  }
`;

const Logo = styled(Link)`
  font-size: 1.5rem;
  font-weight: 800;
  color: #f8fafc;
  text-decoration: none;
  letter-spacing: -0.5px;
  display: flex;
  align-items: center;

  span {
    color: #6366f1;
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
`;

const MenuList = styled.ul`
  display: flex;
  gap: 2.5rem;
  list-style: none;
  align-items: center;

  @media (max-width: 768px) {
    display: ${({ open }) => (open ? 'flex' : 'none')};
    flex-direction: column;
    position: fixed;
    top: 70px;
    left: 0;
    width: 100%;
    height: calc(100vh - 70px);
    background-color: rgba(11, 15, 25, 0.98);
    backdrop-filter: blur(20px);
    padding: 3rem 0;
    gap: 2rem;
    z-index: 999;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }
`;

const MenuItem = styled.li`
  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }
`;

const StyledLink = styled(Link)`
  color: ${({ active }) => (active ? '#6366f1' : '#94a3b8')};
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  padding: 0.5rem 0;

  &:hover {
    color: #f8fafc;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: ${({ active }) => (active ? '100%' : '0')};
    height: 2px;
    background: linear-gradient(90deg, #6366f1, #06b6d4);
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }

  @media (max-width: 768px) {
    font-size: 1.5rem;
    display: inline-block;
    width: 80%;
  }
`;

// Hamburguer Menu Button
const MobileMenuBtn = styled.button`
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;

  &:focus {
    outline: none;
  }

  div {
    width: 2rem;
    height: 0.25rem;
    background: #f8fafc;
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }

    :nth-child(2) {
      opacity: ${({ open }) => (open ? '0' : '1')};
      transform: ${({ open }) => (open ? 'translateX(20px)' : 'translateX(0)')};
    }

    :nth-child(3) {
      transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const menu = [
    { label: 'Home', path: '/' },
    { label: 'Skills', path: '/skills' },
    { label: 'Carreira', path: '/carreira' },
    { label: 'Projetos', path: '/projetos' },
    { label: 'Contato', path: '/contato' }
  ];

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <HeaderContainer>
      <Logo to="/" onClick={handleLinkClick}>
        Danilo<span>Kuwai</span>
      </Logo>

      <Nav>
        <MenuList open={isOpen}>
          {menu.map((item) => (
            <MenuItem key={item.label}>
              <StyledLink
                to={item.path}
                active={location.pathname === item.path ? 1 : 0}
                onClick={handleLinkClick}
              >
                {item.label}
              </StyledLink>
            </MenuItem>
          ))}
        </MenuList>

        <MobileMenuBtn open={isOpen} onClick={toggleMenu}>
          <div />
          <div />
          <div />
        </MobileMenuBtn>
      </Nav>
    </HeaderContainer>
  );
}

export default Header;